import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AdminNotifications from "../components/AdminNotifications";


const NotificationPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Settings - Notification" />

        {/* NotificationLayer */}
        <AdminNotifications />

      </MasterLayout>

    </>
  );
};

export default NotificationPage; 
